export { default } from './DeviceInfoModalContent';
